export interface LexiqueEntry {
  id: string;
  term: string;
  category: 'SEO' | 'GEO' | 'Marketing' | 'Technique' | 'Métrique';
  definition: string;
  example?: string;
  relatedTerms?: string[];
}

export const lexiqueData: LexiqueEntry[] = [
  // SEO
  {
    id: 'lex_001',
    term: 'SEO (Search Engine Optimization)',
    category: 'SEO',
    definition: 'Référencement naturel : ensemble des techniques visant à améliorer la visibilité d\'un site web dans les résultats des moteurs de recherche (Google, Bing, etc.) de manière organique (non payante).',
    example: 'Optimiser le SEO permet d\'apparaître en première page Google sans payer de publicité.',
    relatedTerms: ['SERP', 'Mots-clés', 'Backlinks']
  },
  {
    id: 'lex_002',
    term: 'GEO (Géolocalisation SEO)',
    category: 'GEO',
    definition: 'Référencement local : optimisation pour apparaître dans les résultats de recherche locaux et sur Google Maps. Crucial pour les restaurants et commerces physiques.',
    example: 'Le GEO permet d\'apparaître quand quelqu\'un cherche "restaurant près de moi".',
    relatedTerms: ['GMB', 'Local Pack', 'Citations']
  },
  {
    id: 'lex_003',
    term: 'GMB / GBP (Google My Business / Google Business Profile)',
    category: 'GEO',
    definition: 'Fiche d\'établissement gratuite sur Google qui apparaît dans les recherches locales et Google Maps. Inclut adresse, horaires, photos, avis clients.',
    example: 'Une fiche GMB bien optimisée peut générer +40% de visibilité locale.',
    relatedTerms: ['GEO', 'Avis Google', 'Local Pack']
  },
  {
    id: 'lex_004',
    term: 'Backlinks (Liens entrants)',
    category: 'SEO',
    definition: 'Liens provenant d\'autres sites web pointant vers le vôtre. Plus vous avez de backlinks de qualité (sites reconnus), plus Google considère votre site comme important.',
    example: 'Un article du Michelin Guide mentionnant votre restaurant = backlink très puissant.',
    relatedTerms: ['Domain Authority', 'DoFollow', 'Netlinking']
  },
  {
    id: 'lex_005',
    term: 'Mots-clés (Keywords)',
    category: 'SEO',
    definition: 'Termes et expressions que les internautes tapent dans Google. Identifier les bons mots-clés permet de cibler les recherches les plus pertinentes pour votre business.',
    example: '"restaurant gastronomique paris" = mot-clé à fort volume (12 800 recherches/mois).',
    relatedTerms: ['Volume de recherche', 'Keyword Difficulty', 'Intent']
  },
  {
    id: 'lex_006',
    term: 'Domain Authority (DA)',
    category: 'Métrique',
    definition: 'Score de 0 à 100 qui évalue la "puissance" d\'un site web aux yeux de Google. Plus le DA est élevé, plus il est facile de se positionner.',
    example: 'Le 39V a un DA de 45/100 - potentiel d\'amélioration important.',
    relatedTerms: ['Backlinks', 'Trust Flow']
  },
  {
    id: 'lex_007',
    term: 'Local Pack',
    category: 'GEO',
    definition: 'Encadré de 3 résultats locaux qui apparaît en haut de Google avec une carte. Être dans le Top 3 Local Pack = visibilité maximale.',
    example: 'Recherche "restaurant tour eiffel" → affiche 3 restaurants sur Google Maps.',
    relatedTerms: ['GMB', 'GEO', 'Avis']
  },
  {
    id: 'lex_008',
    term: 'Volume de recherche',
    category: 'Métrique',
    definition: 'Nombre moyen de recherches mensuelles pour un mot-clé donné. Permet d\'estimer le trafic potentiel.',
    example: '"restaurant romantique paris" = 6 700 recherches/mois.',
    relatedTerms: ['Mots-clés', 'Trafic organique']
  },
  {
    id: 'lex_009',
    term: 'KD (Keyword Difficulty)',
    category: 'Métrique',
    definition: 'Difficulté à se positionner sur un mot-clé (0-100). Plus le KD est élevé, plus la concurrence est forte.',
    example: 'KD 78 = très concurrentiel, nécessite beaucoup d\'efforts SEO.',
    relatedTerms: ['Mots-clés', 'Concurrence']
  },
  {
    id: 'lex_010',
    term: 'SERP (Search Engine Results Page)',
    category: 'SEO',
    definition: 'Page de résultats de recherche Google. L\'objectif SEO est d\'apparaître en première page (top 10) voire en position 1-3.',
    example: 'Être en position 1 génère 10x plus de clics qu\'être en position 10.',
    relatedTerms: ['Position', 'Ranking']
  },
  {
    id: 'lex_011',
    term: 'Trafic organique',
    category: 'Métrique',
    definition: 'Nombre de visiteurs arrivant sur votre site via les résultats de recherche naturels (non payants).',
    example: 'Le 39V reçoit 21 visites/mois en organique - potentiel de x10.',
    relatedTerms: ['SEO', 'Volume']
  },
  {
    id: 'lex_012',
    term: 'Intent (Intention de recherche)',
    category: 'SEO',
    definition: 'Objectif de l\'internaute lors de sa recherche : informational (se renseigner), commercial (comparer), transactional (acheter/réserver), navigational (trouver un site).',
    example: '"restaurant paris" = commercial, "réserver le 39v" = transactional.',
    relatedTerms: ['Mots-clés', 'Conversion']
  },
  {
    id: 'lex_013',
    term: 'Hreflang',
    category: 'Technique',
    definition: 'Balise HTML indiquant à Google quelle version linguistique d\'une page afficher selon la localisation de l\'utilisateur.',
    example: 'Hreflang FR/EN/ES permet d\'afficher la bonne langue aux touristes.',
    relatedTerms: ['Internationalisation', 'Multilingue']
  },
  {
    id: 'lex_014',
    term: 'Schema.org / Données structurées',
    category: 'Technique',
    definition: 'Code spécial qui aide Google à mieux comprendre le contenu de votre site (type de restaurant, menu, prix, avis). Essentiel pour les résultats enrichis.',
    example: 'Schema Restaurant affiche vos horaires et note directement dans Google.',
    relatedTerms: ['Rich Snippets', 'JSON-LD']
  },
  {
    id: 'lex_015',
    term: 'Citations (NAP)',
    category: 'GEO',
    definition: 'Mentions de votre restaurant sur d\'autres sites (annuaires, guides) avec Nom, Adresse, Téléphone cohérents. Important pour le référencement local.',
    example: 'TripAdvisor, TheFork, Pages Jaunes = citations locales.',
    relatedTerms: ['GEO', 'Consistance NAP']
  },
  {
    id: 'lex_016',
    term: 'Featured Snippet (Position 0)',
    category: 'SEO',
    definition: 'Encadré de réponse qui apparaît au-dessus des résultats Google (position 0). Génère énormément de clics.',
    example: 'Question "Quel restaurant pour demande en mariage Paris ?" → Featured Snippet possible.',
    relatedTerms: ['SERP', 'FAQ']
  },
  {
    id: 'lex_017',
    term: 'Core Web Vitals',
    category: 'Technique',
    definition: 'Métriques de Google mesurant la vitesse et l\'expérience utilisateur (LCP, FID, CLS). Impact direct sur le référencement.',
    example: 'Site lent = pénalité Google + clients qui partent.',
    relatedTerms: ['Performance', 'UX']
  },
  {
    id: 'lex_018',
    term: 'Long-tail (Longue traîne)',
    category: 'SEO',
    definition: 'Mots-clés très spécifiques avec moins de volume mais plus faciles à cibler et meilleur taux de conversion.',
    example: '"restaurant vue tour eiffel diner romantique" = long-tail très qualifiée.',
    relatedTerms: ['Mots-clés', 'Conversion']
  },
  {
    id: 'lex_019',
    term: 'ROI (Return On Investment)',
    category: 'Marketing',
    definition: 'Retour sur investissement : combien vous gagnez pour chaque euro investi.',
    example: 'ROI 400% = vous gagnez 4€ pour chaque 1€ investi.',
    relatedTerms: ['CA', 'Performance']
  },
  {
    id: 'lex_020',
    term: 'ICE Score',
    category: 'Métrique',
    definition: 'Méthode de priorisation : (Impact × Confiance) / Effort. Permet de choisir les actions à fort impact et faible effort en premier.',
    example: 'ICE 30 = action prioritaire, ICE 5 = action secondaire.',
    relatedTerms: ['Priorisation', 'Quick Wins']
  },
  {
    id: 'lex_021',
    term: 'Cluster de contenu',
    category: 'SEO',
    definition: 'Groupe d\'articles ou pages autour d\'un thème principal. Améliore l\'autorité thématique aux yeux de Google.',
    example: 'Cluster "Fine Dining Paris" : 15 articles autour de la gastronomie parisienne.',
    relatedTerms: ['Content Marketing', 'Autorité']
  },
  {
    id: 'lex_022',
    term: 'Privatisation',
    category: 'Marketing',
    definition: 'Location exclusive de tout ou partie du restaurant pour un événement privé (anniversaire, mariage, séminaire).',
    example: 'Optimiser SEO "privatisation restaurant paris" = capter le marché corporate.',
    relatedTerms: ['Événementiel', 'Corporate']
  },
  {
    id: 'lex_023',
    term: 'Conversion',
    category: 'Marketing',
    definition: 'Action désirée réalisée par un visiteur (réservation, appel, demande de devis). Taux de conversion = % de visiteurs qui réservent.',
    example: 'Taux conversion 2% = 2 réservations pour 100 visiteurs.',
    relatedTerms: ['ROI', 'Réservations']
  },
  {
    id: 'lex_024',
    term: 'Meta Description',
    category: 'Technique',
    definition: 'Texte descriptif de 155 caractères max qui apparaît sous le titre dans Google. Incite au clic.',
    example: 'Bonne meta = "Restaurant gastronomique avec vue Tour Eiffel. Menu dégustation..."',
    relatedTerms: ['Title Tag', 'SEO On-Page']
  },
  {
    id: 'lex_025',
    term: 'Canonical',
    category: 'Technique',
    definition: 'Balise indiquant à Google quelle est la version principale d\'une page (évite le contenu dupliqué).',
    example: 'Utile si vous avez /menu et /carte qui affichent le même contenu.',
    relatedTerms: ['Duplicate Content', 'Indexation']
  },
  {
    id: 'lex_026',
    term: 'Sitemap XML',
    category: 'Technique',
    definition: 'Fichier listant toutes les pages de votre site pour faciliter leur indexation par Google.',
    example: 'Sans sitemap, Google peut rater des pages importantes.',
    relatedTerms: ['Indexation', 'Crawl']
  },
  {
    id: 'lex_027',
    term: 'DoFollow vs NoFollow',
    category: 'SEO',
    definition: 'DoFollow = backlink qui transmet de la "puissance" SEO. NoFollow = backlink sans valeur SEO (mais garde valeur trafic).',
    example: 'Backlink Michelin Guide en DoFollow = très puissant pour le SEO.',
    relatedTerms: ['Backlinks', 'Link Juice']
  },
  {
    id: 'lex_028',
    term: 'Avis Google',
    category: 'GEO',
    definition: 'Évaluations laissées par les clients sur votre fiche Google My Business. Note moyenne et nombre d\'avis impactent fortement le référencement local.',
    example: '4.5★ avec 800 avis > 4.8★ avec 50 avis pour Google.',
    relatedTerms: ['GMB', 'E-réputation', 'Local Pack']
  },
  {
    id: 'lex_029',
    term: 'Landing Page (Page d\'atterrissage)',
    category: 'Marketing',
    definition: 'Page web optimisée pour une requête spécifique, conçue pour convertir les visiteurs.',
    example: 'Page "/restaurant-vue-tour-eiffel" optimisée pour ce mot-clé précis.',
    relatedTerms: ['SEO On-Page', 'Conversion']
  },
  {
    id: 'lex_030',
    term: 'Quick Wins (Gains rapides)',
    category: 'Marketing',
    definition: 'Actions SEO/GEO à faible effort mais fort impact, donnant des résultats en quelques semaines.',
    example: 'Ajouter attributs ALT sur les images = Quick Win technique.',
    relatedTerms: ['ICE Score', 'Priorisation']
  },
  {
    id: 'lex_031',
    term: 'Internationalisation',
    category: 'SEO',
    definition: 'Adaptation du site web pour capter les audiences étrangères (EN/ES/PT). Crucial pour Paris (15M touristes/an).',
    example: 'Version EN optimisée = capter touristes américains et anglais.',
    relatedTerms: ['Hreflang', 'Multilingue']
  },
  {
    id: 'lex_032',
    term: 'SERP Features',
    category: 'SEO',
    definition: 'Éléments spéciaux dans les résultats Google : Featured Snippet, Local Pack, Images, Vidéos, FAQ, etc.',
    example: 'Apparaître dans le Local Pack génère 3x plus de clics.',
    relatedTerms: ['Featured Snippet', 'Rich Results']
  },
  {
    id: 'lex_033',
    term: 'Opportunity Score (Score d\'opportunité)',
    category: 'Métrique',
    definition: 'Note de 0 à 100 évaluant le potentiel d\'un mot-clé (volume, difficulté, pertinence). Aide à prioriser.',
    example: 'Opportunity 95 = mot-clé à cibler en priorité absolue.',
    relatedTerms: ['KD', 'Priorisation']
  },
  {
    id: 'lex_034',
    term: 'Privatisation / Événementiel',
    category: 'Marketing',
    definition: 'Location du restaurant pour événements privés : mariages, séminaires, soirées d\'entreprise. Marché à forte valeur (50k€-200k€/événement).',
    example: 'Optimiser SEO "privatisation restaurant paris" = capter ce marché.',
    relatedTerms: ['Corporate', 'Groupe']
  },
  {
    id: 'lex_035',
    term: 'Taux de conversion',
    category: 'Métrique',
    definition: 'Pourcentage de visiteurs qui effectuent l\'action souhaitée (réservation, appel, devis).',
    example: 'Conversion 8% = 8 réservations pour 100 visiteurs du site.',
    relatedTerms: ['ROI', 'Performance']
  },
  {
    id: 'lex_036',
    term: 'Position moyenne',
    category: 'Métrique',
    definition: 'Classement moyen de votre site dans les résultats Google sur tous vos mots-clés.',
    example: 'Position 12.5 = vous êtes en page 2 en moyenne (invisible).',
    relatedTerms: ['SERP', 'Ranking']
  },
  {
    id: 'lex_037',
    term: 'Visibilité SEO',
    category: 'Métrique',
    definition: 'Score global mesurant votre présence dans les résultats Google. Combine positions, volume de recherche et taux de clic.',
    example: 'Visibilité 78/100 = bonne présence mais améliorable.',
    relatedTerms: ['Trafic organique', 'Positions']
  },
  {
    id: 'lex_038',
    term: 'Content Marketing',
    category: 'Marketing',
    definition: 'Création de contenu (articles, guides, vidéos) pour attirer et convertir votre audience cible.',
    example: 'Blog "10 meilleurs restaurants romantiques Paris" = Content Marketing.',
    relatedTerms: ['SEO', 'Autorité']
  },
  {
    id: 'lex_039',
    term: 'H1, H2, H3... (Headings)',
    category: 'Technique',
    definition: 'Balises de titre HTML structurant le contenu de la page. H1 = titre principal, H2 = sous-titres, etc. Crucial pour le SEO.',
    example: 'H1: "Restaurant gastronomique Paris 8ème", H2: "Notre menu", etc.',
    relatedTerms: ['SEO On-Page', 'Structure']
  },
  {
    id: 'lex_040',
    term: 'Alt Text (Attribut ALT)',
    category: 'Technique',
    definition: 'Description textuelle d\'une image, lue par Google et les lecteurs d\'écran (accessibilité).',
    example: 'ALT: "Plat gastronomique foie gras restaurant Le 39V Paris".',
    relatedTerms: ['Images', 'Accessibilité']
  },
  {
    id: 'lex_041',
    term: 'Crawl / Indexation',
    category: 'Technique',
    definition: 'Processus par lequel Google explore votre site (crawl) puis ajoute vos pages à sa base de données (indexation).',
    example: 'Sans sitemap, Google peut mettre des mois à indexer vos nouvelles pages.',
    relatedTerms: ['Sitemap', 'Robots.txt']
  },
  {
    id: 'lex_042',
    term: 'E-réputation',
    category: 'Marketing',
    definition: 'Image de votre restaurant sur internet : avis clients, articles, réseaux sociaux. Impact direct sur les réservations.',
    example: 'Répondre à 100% des avis en -24h améliore votre e-réputation.',
    relatedTerms: ['Avis Google', 'Social Media']
  },
  {
    id: 'lex_043',
    term: 'SSL / HTTPS',
    category: 'Technique',
    definition: 'Protocole de sécurité (cadenas dans le navigateur). Obligatoire pour le SEO et la confiance clients.',
    example: 'Site en HTTP (sans SSL) = pénalisé par Google.',
    relatedTerms: ['Sécurité', 'Trust']
  },
  {
    id: 'lex_044',
    term: 'Responsive Design',
    category: 'Technique',
    definition: 'Site qui s\'adapte à tous les écrans (mobile, tablette, desktop). Google privilégie les sites mobile-friendly.',
    example: '60% des recherches restaurant se font sur mobile.',
    relatedTerms: ['Mobile-First', 'UX']
  },
  {
    id: 'lex_045',
    term: 'UX (User Experience)',
    category: 'Marketing',
    definition: 'Expérience utilisateur sur votre site. UX fluide = meilleur taux de conversion et boost SEO.',
    example: 'Menu illisible sur mobile = mauvaise UX = visiteurs partent.',
    relatedTerms: ['Conversion', 'Core Web Vitals']
  }
];

export const getLexiqueByCategory = (category: LexiqueEntry['category']): LexiqueEntry[] => {
  return lexiqueData.filter(entry => entry.category === category);
};

export const searchLexique = (query: string): LexiqueEntry[] => {
  const lowercaseQuery = query.toLowerCase();
  return lexiqueData.filter(entry => 
    entry.term.toLowerCase().includes(lowercaseQuery) ||
    entry.definition.toLowerCase().includes(lowercaseQuery)
  );
};

export const getLexiqueCategories = (): string[] => {
  return Array.from(new Set(lexiqueData.map(entry => entry.category)));
};











